import React, { useEffect, useState } from 'react';
import { baseURL } from '../Constants'; // Import the baseURL constant

type PlayerImageProps = {
    id: string;
    width?: number;
};

const PlayerImage = ({ id, width }: PlayerImageProps) => {
    const [imageSrc, setImageSrc] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const checkBackendForImage = async () => {
            try {
                const width = 400; // Adjust based on your requirements
                const backendUrl = `${baseURL}/Account/Profile/${id}?width=${width}`;
    
                const response = await fetch(backendUrl, { method: 'HEAD' });
                if (response.ok) {
                    setImageSrc(backendUrl);
                } else {
                    setImageSrc(`https://report.dpl.gg/powerfiles/ligaen/getPlayerPicture.php?id=${id}&width=${width}`);
                }
            } catch (error) {
                console.error('Error checking image:', error);
                setImageSrc(`https://report.dpl.gg/powerfiles/ligaen/getPlayerPicture.php?id=${id}&width=400`);
            } finally {
                setLoading(false);
            }
        };
    
        checkBackendForImage();
    }, [id]);
    

    if (loading) {
        return <div>Loading...</div>; // Optional loading state
    }

    return <img src={imageSrc} alt="Player" style={{ width }} loading="lazy" />;
};

export default PlayerImage;
